<ng-container *ngIf="actionRequire$ | async as actionRequire">
  <div class="lp-top-notification" *ngIf="actionRequire.length > 0">
  <mat-expansion-panel class="warn-message mat-elevation-z" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span class="notification-title">
          <mat-icon class="notranslate">error_outline</mat-icon>
          Action Required ({{actionRequire.length}})
        </span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ol class="action-list">
        <li *ngFor="let item of actionRequire">{{item.msg}} 
          <a *ngIf="!!item.link" [routerLink]="item.link">View details</a>
          <button *ngIf="!item.link && !!item.click" class="action-list-btn" mat-stroked-button (click)="item.click()">
            Review
          </button>
        </li>
    </ol>
  </mat-expansion-panel>
</div>
</ng-container>
